import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, Component } from 'react';
import OtherClickListener from '../../events/OtherClickListener';
import { propBool, propChildren, propFunc, propStr, } from '../../helpers/custom-prop-types';
class HeaderHumMenu extends Component {
    constructor(props) {
        super(props);
        this.clickRef = createRef();
        this.clickListenerNo = null;
    }
    componentDidMount() {
        const { hideSpHum } = this.props;
        this.clickListenerNo = OtherClickListener.setListener(this.clickRef.current, hideSpHum);
    }
    componentWillUnmount() {
        OtherClickListener.deleteListener(this.clickListenerNo);
    }
    render() {
        const { children, className, isShowSpHum, toggleSpHum } = this.props;
        return (_jsxs("div", Object.assign({ className: `hum-menu ${className}`, ref: this.clickRef }, { children: [_jsx("i", Object.assign({ className: `material-icons hov-icon sp-menu ${isShowSpHum ? 'active' : ''}`, onClick: toggleSpHum, role: 'presentation' }, { children: "menu" })), _jsx("nav", Object.assign({ className: `hum-menu-body ${isShowSpHum ? 'is-visible' : ''}` }, { children: children }))] })));
    }
}
HeaderHumMenu.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    hideSpHum: propFunc().isRequired,
    isShowSpHum: propBool().isRequired,
    toggleSpHum: propFunc().isRequired,
};
HeaderHumMenu.defaultProps = {
    className: '',
};
export default HeaderHumMenu;
